<template>
  <div class="layout-wrapper layout-2">
    <div class="layout-inner">
      <AppSidenav v-if="sidenavEnabled" />
      <div class="layout-container" :class="{ 'layout-without-sidebar': !sidenavEnabled || sidenavDrawer }">
        <AppNavbar :sidenav-enabled="sidenavEnabled" />
        <div class="layout-content">
          <TimezoneStaleNotice v-if="isUserSigned" />
          <router-view />
        </div>
      </div>
    </div>
    <div class="layout-overlay"></div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AppNavbar from '@/components/core/AppNavbar.vue'
import AppSidenav from '@/components/core/AppSidenav.vue'
import TimezoneStaleNotice from '@/components/core/TimezoneStaleNotice.vue'
import { SIDENAV_CLASSES } from '@/store'

// not in SIDENAV_CLASSES: the store plugin clears those on every open/close
const SIDENAV_DRAWER_CLASS = 'layout-sidenav-drawer'

export default {
  components: {
    AppNavbar,
    AppSidenav,
    TimezoneStaleNotice
  },
  computed: {
    ...mapGetters('auth', ['isUserSigned', 'isUserAdmin']),
    sidenavEnabled() {
      return this.isUserSigned
    },
    sidenavDrawer() {
      return this.sidenavEnabled && !this.isUserAdmin
    }
  },
  methods: {
    ...mapActions(['setSidenavClass'])
  },
  watch: {
    sidenavEnabled: {
      immediate: true,
      handler(current) {
        this.setSidenavClass(current ? false : SIDENAV_CLASSES.disabled)
      }
    },
    sidenavDrawer: {
      immediate: true,
      handler(current) {
        document.documentElement.classList.toggle(SIDENAV_DRAWER_CLASS, current)
      }
    }
  },
  beforeDestroy() {
    document.documentElement.classList.remove(SIDENAV_DRAWER_CLASS)
  }
}
</script>
<style>
.layout-without-sidebar {
  padding-left: 0 !important;
}
</style>
